import { Component, HostListener, OnInit, ViewEncapsulation } from '@angular/core';
import { TimelineModule } from 'primeng/timeline';
import { CardModule } from 'primeng/card';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-newmember-widget',
    standalone: true,
    imports: [
        CommonModule, 
        TimelineModule, 
        CardModule],
    templateUrl: './newmemberwidget.component.html',
    styleUrls: ['./newmemberwidget.component.scss'],
    encapsulation: ViewEncapsulation.None // Ensures styles are applied globally
})
export class NewMemberWidgetComponent implements OnInit {
    timelineAlign: string = 'alternate'; // Default alignment

    bpvcommunity: any[] = [];
    bpvliga: any[] = [];

    ngOnInit(): void {
        this.updateTimelineAlignment(); // Set initial alignment based on window size
        this.bpvcommunity = [
            {
                headerline: '<a href=\"https://discord.gg/9X2a4YZmCW\" target=\"_blank\">Discord beitreten</a>',
                description: 'Poste deinen GT7/PSN Namen im #psn-namen Kanal. Damit bist du für alle sichtbar und jeder kann dich zu seinen Freunden hinzufügen.',
                icon: 'pi pi-discord',
                color: '#9C27B0',
                image: '/newmembers/Item-Community-addname.png'
            },
            {
                headerline: 'Freunde hinzufügen',
                description: 'Füge Leute im PSN hinzu, die du kennst oder mit denen du gerne fahren möchtest. So kannst du sie direkt zu einem Rennen einladen. Die meisten Lobbies werden Friends-Only gestartet.',
                icon: 'pi pi-users',
                color: '#673AB7',
                image: '/newmembers/Item-Community-addfriend.png'
            },
            {
                headerline: 'An Gesprächen teilnehmen / Unterstützung holen',
                description: 'Im Discord gibt es viele Kanäle, in denen du Fragen stellen kannst. Wir helfen dir gerne weiter. Es bilden sich immer wieder Gruppen im PSN Voice Chat, die gemeinsam reden und fahren.',
                icon: 'pi pi-comments',
                color: '#FF9800',
                image: '/newmembers/Item-Community-talk.png'
            },
            {
                headerline: 'An Events teilnehmen / Events selbst organisieren',
                description: 'Wir haben regelmäßige Events, an denen du teilnehmen kannst. Du kannst auch eigene Events organisieren und die Community dazu einladen.',
                icon: 'pi pi-calendar',
                color: '#4CAF50',
                image: '/newmembers/Item-Community-events.png'
            },
            {
                headerline: 'Kreativität ausleben',
                description: 'Erstelle und Teile Bilder/Videos von deinen Rennen oder anderen Dingen. Der Kreativität sind keine Grenzen gesetzt und alle freuen sich über jegliche Abwechslung.',
                icon: 'pi pi-image',
                color: '#FFC107',
                image: '/newmembers/Item-Community-creative.png'
            }
        ];

        this.bpvliga = [
            {
                headerline: 'Rennleitung kontaktieren / Gruppenzuweisung abholen',
                description: 'Du kannst dich jederzeit für die Liga anmelden, auch wenn sie schon gestartet ist. Die Rennleitung ist in Discord und PSN erreichbar. Sie wird dich aufklären und dich zu einer Gruppe zuweisen.',
                icon: 'pi pi-check',
                color: '#9C27B0',
                image: '/newmembers/Item-League-signup.png'
            },
            {
                headerline: 'BPV-Liga Kanäle lesen / informieren',
                description: 'Alle Liga-Informationen sind in den Discord Liga-Kanälen zu finden. Hier findest du alle Informationen zu den Rennen, den Gruppen und den Regeln.',
                icon: 'pi pi-book',
                color: '#673AB7',
                image: '/newmembers/Item-League-info.png'
            },
            {
                headerline: 'Rennleitung / Liga-Host als Freund hinzufügen',
                description: 'Füge die Rennleitung und den Liga-Host als Freunde hinzu, damit du die Lobby sehen und dort beitreten kannst. Du kannst sie auch direkt im PSN anschreiben.',
                icon: 'pi pi-user-plus',
                color: '#FF9800',
                image: '/newmembers/Item-League-addfriend.png'
            },
            {
                headerline: 'Zu den Liga-Rennen sich an-/abmelden',
                description: 'Melde dich zu dem jeweiligen Rennen in Discord an. Damit hilfst du der Rennleitung, die Lobbys zu erstellen. Du kannst dich auch wieder abmelden, wenn du nicht teilnehmen kannst.',
                icon: 'pi pi-calendar',
                color: '#4CAF50',
                image: '/newmembers/Item-League-checkin.png'
            },
            {
                headerline: 'Zu Liga-Zeiten online sein und an den Rennen teilnehmen',
                description: 'Sei zu den Liga-Zeiten online und nimm an den Rennen teil. Die Lobby wird immer 30 Minuten vorher geöffnet. Du kannst gerne dort reingehen und dich bis zum Rennstart mit anderen Fahrern unterhalten.',
                icon: 'pi pi-gauge',
                color: '#FFC107',
                image: '/newmembers/Item-League-race.png'
            }
        ];
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: Event): void {
        this.updateTimelineAlignment();
    }

    private updateTimelineAlignment(): void {
        this.timelineAlign = window.innerWidth < 768 ? 'left' : 'alternate'; // Change to 'left' if window width is less than 768px
    }
}
